var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7fccec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe3"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8332",
    transform: "translate(-453 -571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8125",
    transform: "translate(-1 -42)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#linear-gradient)",
    transform: "translate(454 613)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8204",
    transform: "translate(-541 283.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6394",
    d: "M0 0H2V15H0z",
    className: "cls-2",
    transform: "rotate(45 149.818 1374.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6395",
    d: "M0 0H2V8H0z",
    className: "cls-2",
    transform: "rotate(135 440.343 362.36)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.413897c01a0cbd232053e5fada659754.svg";
export { ForwardRef as ReactComponent };